import { Component, OnInit ,ViewChild, ElementRef} from '@angular/core';
import * as html2pdf from 'html2pdf.js';
@Component({
  selector: 'app-testing-file',
  templateUrl: './testing-file.component.html',
  styleUrls: ['./testing-file.component.css']
})
export class TestingFileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


   @ViewChild('invoice', { static: false }) invoiceElement!: ElementRef;

  invoiceData = {
    invoiceNumber: 'INV-2025-001',
    date: new Date().toLocaleDateString(),
    customer: 'John Doe',
    items: [
      { name: 'Product A', quantity: 2, price: 500 },
      { name: 'Product B', quantity: 1, price: 1200 },
    ],
  };

  getTotal(): number {
    return this.invoiceData.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }

   downloadPDF() {
    const element = this.invoiceElement.nativeElement;

    setTimeout(() => {
      const opt = {
        margin: 0.3,
        filename: `Invoice-${this.invoiceData.invoiceNumber}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      };

      html2pdf().from(element).set(opt).save();
    }, 100); // small delay to ensure rendering
  }



}
